<template>
    <v-app>
        <v-toolbar color="primary" dark fixed>
            <v-toolbar-title>Songa Insurance</v-toolbar-title>
            <div class="d-flex align-center" style="margin-left: auto">
                <v-btn flat @click="routeHandler('login')">
                <v-icon left>lock_open</v-icon>
                Login
                </v-btn>
                <v-btn flat @click="routeHandler('register')">
                    <v-icon left>person_add</v-icon>
                    Register
                </v-btn>
            </div>
        </v-toolbar>
        <main>
        <v-container fluid fill-height>
            
            <router-view></router-view>

        </v-container>
        </main>
    </v-app>
</template>

<script>
export default {
    name: 'auth',
    data() {
        return {
        }
    },
    methods: {
        routeHandler(route) {
            this.$router.push('/auth/' + route)
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/auth/Auth.vue